import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flex items-center text-lg" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'vaccinazioniModalHeader',
    props: {
        title: String
    },
    setup: function (__props) {
        var props = __props;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1));
        };
    }
});
